import React from 'react'
import { Link } from 'react-router-dom'

export default function Error() {
  return (
    <>
      <section className='error-area'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8 text-center'>
              <img src='/image/404.webp' alt='404' />
              <p>Looks like this page <br />
                {"doesn’t exist anymore :("}</p>
              <Link to={"/"} className="default-btn color-btn">GO TO HOME PAGE</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
